import { Component } from '@angular/core';
import { ConfigProvider } from 'providers/config/config';

@Component({
  selector: 'app-aside',
  templateUrl: './app-aside.component.html'
})
export class AppAsideComponent {
  perfilUsuario: any;
  constructor( public configProvider: ConfigProvider) {
    this.perfilUsuario = JSON.parse(this.configProvider.getConfigData());
   }
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-aside/app-aside.component.ts